import { render, staticRenderFns } from "./CompleteQueueEvent.vue?vue&type=template&id=3c80f3da&scoped=true&"
import script from "./CompleteQueueEvent.vue?vue&type=script&lang=js&"
export * from "./CompleteQueueEvent.vue?vue&type=script&lang=js&"
import style0 from "./CompleteQueueEvent.vue?vue&type=style&index=0&id=3c80f3da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c80f3da",
  null
  
)

export default component.exports